export default "__VITE_ASSET__DYbsZWnX__"